import { defineManifest } from "@tc/sdk";
import { PROJECT_TASKS } from "./tasktypes.js";
export const manifest = defineManifest({
    id: "projects",
    name: "Projects",
    version: "0.1.0",
    tier: "addon",
    accent: "brand",
    dependsOn: ["sites"],
    description: "Plan and run refits, new sites, equipment installs and promotions: tasks on a board, a timeline, budget and spend, status updates, and one dashboard for every project.",
    permissions: {
        view: "See projects at your sites (and any you're on), comment, and work on tasks in projects you're a member of",
        create: "Start projects (blank or from a template) and run the ones you own",
        manage: "Head office: every project that isn't private, templates, categories and settings",
    },
    grants: {
        "Head office": ["view", "create", "manage"],
        "Area manager": ["view", "create"],
        "Site manager": ["view", "create"],
        Supervisor: ["view"],
        Staff: ["view"],
    },
    tasks: PROJECT_TASKS,
    widgets: [
        { key: "mine", title: "My project tasks", description: "Your project tasks that are overdue or due in the next few days.", group: "Jobs", size: 1, permission: "view", defaultOn: true, order: 62, live: true },
        { key: "glance", title: "Projects at a glance", description: "Active projects, worst health first, with progress and the next milestone.", group: "Jobs", size: 2, permission: "view", defaultOn: false, order: 63, live: true },
    ],
    nav: [
        { label: "Projects", path: "/projects", section: "tasks", tabIcon: "layers", tab: "Projects", permission: "view", icon: "layers", order: 15, blurb: "Refits, openings and installs: board, timeline, budget and updates" },
        { label: "Project templates", path: "/projects/templates", section: "tasks", kind: "settings", permission: "manage", icon: "copy", order: 90, blurb: "Ready-made plans for refits, openings, tank works and more" },
        { label: "Project settings", path: "/projects/settings", section: "tasks", kind: "settings", permission: "manage", icon: "settings", order: 91, blurb: "Categories, reminders and when tasks show as due soon" },
    ],
});
